var style = {"z-h1":"z-h1","z-h2":"z-h2","z-h3":"z-h3","z-h4":"z-h4"};

export { style as default };
//# sourceMappingURL=Heading.module.scss.js.map
